<template>
   <div class="page-number">
     <div class="number numberOne active">1</div>
     <div class="number numberTwo active">2</div>
     <div class="number numberThree active">3</div>
     <div class="number numberFour active">4</div>
  </div>
</template>

<script>

export default {
  name: 'page-number',
  props:{
  }
}
</script>

<style scoped>

.page-number
{
  position: absolute;
  bottom: 30px;
  right: 22.5vw;
  letter-spacing: -3px;
  display: none;
}

.number
{
  display: inline-block;
  transition: 0.3s;
  padding: 5px 10px;
  margin: 0 5px;
  border-bottom: 2px solid white;
  opacity: 0.5;
  vertical-align: bottom;
}

.number:hover
{
  opacity: 1;
  font-size: 1.5em;
}

.current-number
{
  border-bottom: 4px solid #2778F3;
  opacity: 1;
  color: #2778F3;
  text-shadow: #2778F3 0px 0px 20px;
  font-size: 2em !important;
}

@media only screen and (max-width: 900px) {
  .page-number
  {
    display: none !important;
  }
}

</style>
